module.exports = __webpack_public_path__ + "img/icon_category_03.643f430c.svg";